let initialState = {
  webAppPath: (new URL(appConfig.webAppURL)).pathname,
  errorList: [],
  activeRequests: [],
  invalidAttributes: {
    userName: "",
    email: ""
  },
  account: null,
  sid: null,
  loginType: "sid",
  responseCode: null
};

export const state = initialState;



// WEBPACK FOOTER //
// ./webapp/store/state.js